<script setup lang="ts">
withDefaults(defineProps<{
  label?: string
}>(), {
  label: undefined,
})
</script>

<template>
  <figure class="rounded-[8px] overflow-hidden border-[1.5px] border-brand-ink bg-brand-chalk shadow-[0_10px_0_rgba(0,0,0,0.1)]">
    <header class="flex items-center gap-2 px-3 py-2 border-b-[1.5px] border-brand-ink bg-brand-chalk">
      <span class="size-3 rounded-full bg-brand-red"/>
      <span class="size-3 rounded-full bg-brand-yellow"/>
      <span class="size-3 rounded-full bg-brand-ink/30"/>
      <figcaption
        v-if="label"
        class="ml-3 font-display uppercase text-[10px] tracking-[0.14em] text-brand-ink/70 truncate"
      >
        {{ label }}
      </figcaption>
    </header>
    <div class="relative">
      <slot/>
    </div>
  </figure>
</template>
